import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import MakeLogo from '../logos/make.svg';
export const GetMakeCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            MakeCardTID: {
                Card: 'make-card',
                Connect: 'make-card-connect'
            }
        }
    });
export default function MakeCard() {
    const { t: makeTexts } = useLocaleKeys('integrations.availableApps.make');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('make');
    const { MakeCardTID } = useMemo(()=>GetMakeCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: MakeCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(MakeLogo, {
            width: 40,
            height: 40
        }),
        title: makeTexts.title(),
        subTitle: makeTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_make'
            },
            onClick: showCopyAPIKeyModal,
            testId: MakeCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
